<template>
    <div>
        <div id="contact-us" class="bg-gradient inverted page">
            <b-container>
                <h3 class="text-center" v-tr>Contact Us|Contactez-nous</h3>
                <h4 class="text-center" v-tr>For a free Demo and Consultation|Pour une démo gratuite ou une consultation</h4>

                <b-row class="mt-3">
                    <b-col cols="12" md="4" lg="3">
                        <div class="btn-group text-center mb-3 d-flex" style="max-width: 200px;">
                            <b-btn size="sm" class="f-500 text-spaced" @click="country = 'ca'" :variant="country === 'ca' ? 'primary' : 'light'">Canada</b-btn>
                            <b-btn size="sm" class="f-500 text-spaced" @click="country = 'us'" :variant="country === 'us' ? 'primary' : 'light'">USA</b-btn>
                        </div>
                        <b-media class="mb-3">
                            <template #aside>
                                <div class="avatar">
                                    <i class="fal fa-phone"></i>
                                </div>
                            </template>
                            <b v-tr>Phone Number|Téléphone</b><br>
                            <a v-show="country === 'ca'" class="text-secondary" href="tel:5143959327">+1 (514) 395-9327</a>
                            <a v-show="country === 'us'" class="text-secondary" href="tel:3055149829">+1 (305) 514-9829</a>
<!--                            <a v-show="country === 'us'" class="text-secondary" href="tel:4247810414">+1 (424) 781-0414</a>-->
                        </b-media>
                        <b-media class="mb-3">
                            <template #aside>
                                <div class="avatar">
                                    <i class="fal fa-envelope"></i>
                                </div>
                            </template>
                            <b v-tr>E-mail|Courriel</b><br>
                            <a class="text-secondary" href="mailto:info@eyeinmedia.com">info@eyeinmedia.com</a>
                        </b-media>
                        <b-media>
                            <template #aside>
                                <div class="avatar">
                                    <i class="fal fa-location-arrow"></i>
                                </div>
                            </template>
                            <b v-tr>Address|Adresse</b><br>
                            <div v-show="country === 'ca'" class="mb-3">
                                <div v-tr>1275 Avenue des <br> Canadiens-de-Montréal</div>
                                Suite 500<br>Montréal, QC H3B 0G4
                            </div>
                            <div v-show="country === 'us'" class="mb-3">
                                <div>17100 N Bay Road <br> Unit 1718</div>
                                North Miami Beach, FL 33160
                            </div>
<!--                            <div v-show="country === 'us'" class="mb-3">-->
<!--                                <div>802 El Oro Lane</div>-->
<!--                                Pacific Palisades, CA<br>90272-->
<!--                            </div>-->
                        </b-media>
                    </b-col>
                    <b-col cols="12" md="8" lg="9" class="pt-3">
                        <contact-form></contact-form>
                    </b-col>
                </b-row>
            </b-container>
        </div>

        <div id="footer" class="page inverted">
            <b-container>
                <b-row>
                    <b-col cols="12" md="6" lg="3">
                        <h5 v-tr>Products|Produits</h5>
                        <div><a href="https://eyeintelligence.com" target="_blank">Eye-Intelligence</a></div>
                        <div><router-link :to="'/digital-signage/storyboard/infinite|/affichage-numerique/storyboard/infinite'|tr" target="_blank">Eye-In Storyboard Infinite</router-link></div>
                        <div><a href="https://eyeinspire.ca" target="_blank">Eye-Inspire</a></div>
                        <div><a href="https://thefoodforce.com" target="_blank">TheFoodForce</a></div>
                        <div><a href="https://only1generation.com" target="_blank">Only1 Generation</a></div>
                    </b-col>
                    <b-col cols="12" md="6" lg="3">
                        <h5 v-tr>Digital Signage Solutions|Solutions d'affichage</h5>
                        <div>
                            <b-btn variant="primary" class="mb-2"  href="https://digitalsignage.expert/s/shop?utm_source=eye_in_website&utm_medium=referral&utm_campaign=corpo_website&utm_content=buy_footer" target="_blank">
                                <i class="fas fa-cart-shopping-fast mr-2"/>
                                <span v-tr>Buy Online|Acheter en ligne</span>
                            </b-btn>
                        </div>
                        <div><router-link :to="'/digital-signage/menuboards|/affichage-numerique/menus-restaurants'|tr" v-tr>Menu Boards|Menu numériques</router-link></div>
                        <div><router-link :to="'/restauration/menuboard-designer|/restauration/conception-et-design-menus'|tr">Storyboard Menu Designer|Outil création menus</router-link></div>
                        <div><router-link :to="'/restauration/digital-signage-for-restaurants|/restauration/affichage-numerique-pour-restaurants'|tr" v-tr>Digital Signage for Restaurants|Affichage numérique pour restaurants</router-link></div>
                        <div><router-link :to="'/digital-signage/videowalls|/affichage-numerique/mur-ecrans-video'|tr" v-tr>Video Walls|Murs vidéo</router-link></div>
                        <div><router-link :to="'/digital-signage/holograms|/affichage-numerique/hologrammes'|tr" v-tr>3D Holograms|Hologrammes 3D</router-link></div>
                        <div><router-link :to="'/restauration/easy-self-ordering|/restauration/commande-autonome'|tr" v-tr>Self-Ordering|Commande autonome</router-link></div>
                    </b-col>
                    <b-col cols="12" md="6" lg="3">
                        <h5 v-tr>WiFi Solutions|Solutions de WiFi</h5>
                        <div><router-link :to="'/wifi/guest-social-wifi|/wifi-public/wifi-public-et-social'|tr" v-tr>Guest & Social WiFi|WiFi public et social</router-link></div>
                        <div><router-link :to="'/wifi/retail-shopping-mall|/wifi-public/commerces-et-centres-commerciaux'|tr" v-tr>WiFi CRM for Malls & Retail|CRM WiFi pour détaillants</router-link></div>
                        <div><router-link :to="'/wifi-on-board/coaches-and-bus|/wifi-a-bord/bus-et-navettes'|tr" v-tr>WiFi On Board (bus)|WiFi à bord (bus)</router-link></div>
                        <h5 class="mt-3" v-tr>Mobile Applications|Applications mobiles</h5>
                        <div><router-link :to="'/mobile-apps/universal-applications|/applications-mobiles/app-universelles'|tr" v-tr>Mobile Applications|Applications mobiles</router-link></div>
                    </b-col>
                    <b-col cols="12" md="6" lg="3">
                        <h5 v-tr>Resources</h5>
                        <div><router-link to="/blog" v-tr>Our blog|Notre blog</router-link></div>
                        <div><router-link :to="'/about-us|/a-propos-de-nous'|tr" v-tr>About us|À propos</router-link></div>

                        <h5 class="mt-4" v-tr>Stay in contact|Restez en contact</h5>
                        <b-btn variant="light" class="btn-social" target="_blank"
                               :title="'Follow us on Facebook|Suivez nous sur Facebook'|tr"
                               href="https://www.facebook.com/EyeInMedia">
                            <b-img-lazy width="20" height="20" alt="Follow us on Facebook" :src="require('../assets/img/font-awesome/facebook-brands.svg')"></b-img-lazy>
                        </b-btn>
                        <b-btn variant="light" class="btn-social ml-2" target="_blank"
                               :title="'Follow us on Linkedin|Suivez nous sur Linkedin'|tr"
                               href="https://www.linkedin.com/company/eye-in-media">
                            <b-img-lazy width="20" height="20" alt="Follow us on Linkedin" :src="require('../assets/img/font-awesome/linkedin-brands.svg')"></b-img-lazy>
                        </b-btn>
<!--                        <b-btn variant="light" class="btn-social ml-2" target="_blank"-->
<!--                               :title="'Follow us on Twitter|Suivez nous sur Twitter'|tr"-->
<!--                               href="https://twitter.com/EyeInMedia">-->
<!--                            <b-img-lazy width="20" height="20" alt="Follow us on Twitter" :src="require('../assets/img/font-awesome/twitter-brands.svg')"></b-img-lazy>-->
<!--                        </b-btn>-->
                        <b-btn variant="light" class="btn-social ml-2" target="_blank"
                               :title="'Visit our YouTube Channel|Visitez notre chaîne YouTube'|tr"
                               href="https://www.youtube.com/channel/UCBZS0V_w-aRr-PY8HCViHKA">
                            <b-img-lazy width="20" height="20" alt="Visit our YouTube Channel" :src="require('../assets/img/font-awesome/youtube-brands.svg')"></b-img-lazy>
                        </b-btn>
                    </b-col>
                </b-row>
                <div class="d-block mt-4 text-center">
                    <b-img width="350" :src="require('../assets/img/branding/logo-20-years-white.png')"/>
                    <p class="f-500" v-tr>© Copyright Eye-In Media {{new Date().getFullYear()}}|Tout droits réservés Eye-In Media ©  {{new Date().getFullYear()}}</p>
                    <p>
                        <router-link class="text-underline" :to="'/terms-and-policies/privacy-policy|/termes-et-conditions/privacy-policy'|tr">
                            <span v-tr>Data Privacy Policy|Politique de Confidentialité</span>
                        </router-link>
                    </p>
                    <div v-if="isFrench()">
                        Où la vision devient réalité - Fier partenaire de <a target="_blank" href="https://www.samsung.com/">Samsung</a>,
                        <a target="_blank" href="https://www.cisco.com/">Cisco</a>,
                        <a target="_blank" href="https://meraki.cisco.com/">Meraki</a>
                        et <a target="_blank" href="https://hypervsn.com/">HyperVSN</a>
                    </div>
                    <div v-else>
                        Where vision meets reality - Proud partner with <a target="_blank" href="https://www.samsung.com/">Samsung</a>,
                        <a target="_blank" href="https://www.cisco.com/">Cisco</a>,
                        <a target="_blank" href="https://meraki.cisco.com/">Meraki</a>
                        and <a target="_blank" href="https://hypervsn.com/">HyperVSN</a>
                    </div>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
    import ContactForm from "@/components/contact-form.vue";
    import {isFrench} from "../../vue-components/helpers/i18n";

    export default {
        name: `app-footer`,
        components: {ContactForm},
        data() {
            return {
                isFrench: isFrench,
                country: `ca`
            }
        },
        computed: {
            iframeSrc() {
                return encodeURI(`https://maps.google.com/maps?width=100%&height=400&hl=en&q=1 westmount square+(Eye-In Media)&ie=UTF8&t=&z=14&iwloc=B&output=embed`);
            }
        }
    }
</script>

<style lang="scss" scoped>
    footer {
        /*box-shadow: inset 0 10px 10px 5px rgba(0, 0, 0, 0.15);*/
        padding: 30px;
    }
</style>
